import { ListingResultProps } from '@app/core/reports/components/ListingView';
import { Report, toDateTimeStr } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { LDate } from '../../../../../components/date/LDate';
import { LTime } from '../../../../../components/date/LTime';
import { ReportTypeChip } from '../../../../../components/ReportTypeChip';
import { getAppUserDisplayName } from '../../../../../helpers/user';
import { ReportListStatus } from './ReportListStatus';
import { ReportListType } from './types';

export function ReportsListView(props: ListingResultProps<ReportListType>) {
  const { formatMessage } = useIntl();

  return (
    <MrtTable<Report>
      {...props.mrtProps}
      navigateToOnClick={(id) => `/audit/saved-reports/${id}`}
      columns={[
        {
          id: 'time',
          header: formatMessage({
            id: 'audit.report.created',
            defaultMessage: 'Creado',
          }),
          accessorFn: (row) => row.createdAt,
          Cell: ({ row: { original } }) => (
            <div style={{ display: 'flex', gap: '0.375rem' }}>
              <LDate
                value={toDateTimeStr(original.createdAt)}
                day="2-digit"
                month="2-digit"
                year="2-digit"
              />
              <LTime value={toDateTimeStr(original.createdAt)} />
            </div>
          ),
          size: 100,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
          id: 'type',
          enableSorting: false,
          accessorFn: (row) => row.type,
          Cell: ({ row: { original } }) => {
            return <ReportTypeChip reportType={original.type} />;
          },
          header: formatMessage({
            id: 'audit.reportsList.type',
            defaultMessage: 'Tipo',
          }),
          size: 90,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
          header: formatMessage({
            id: 'audit.report.name',
            defaultMessage: 'Nombre',
          }),
          enableGlobalFilter: true,
          enableColumnFilter: false,
          accessorFn: (row) => row.name,
          Cell: ({ row: { original } }) => {
            return original.name;
          },
          size: 150,
        },
        {
          header: formatMessage({
            id: 'audit.reportsList.createdBy',
            defaultMessage: 'Creado por',
          }),
          accessorFn: (row) => row.createdBy,
          Cell: ({ row: { original } }) => {
            return original.createdBy ? (
              <div className="ml-1 text-gray-600">{getAppUserDisplayName(original.createdBy)}</div>
            ) : (
              <FormattedMessage id="audit.reportsView.createdByUnknown" defaultMessage="Sin datos">
                {(txt) => <span className="text-muted">{txt}</span>}
              </FormattedMessage>
            );
          },
          size: 100,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
        {
          header: formatMessage({
            id: 'audit.reportsList.exportStatus',
            defaultMessage: 'Status de export',
          }),
          Cell: ({ row: { original } }) => <ReportListStatus report={original}></ReportListStatus>,
          size: 100,
          enableColumnFilter: false,
          enableGlobalFilter: false,
        },
      ]}
      enableExpandAll={false}
      enableGlobalFilter
      enableFilters={true}
      memoizeColumns={false}
      enableHiding={false}
      enableColumnActions={false}
    />
  );
}
